<template>
  
  <div>
  <div v-if="isExist&&!linkIAmSmart&&!isCompleted">The digital certificate is registered as a ESH account. Please login to activate your professional role.</div>
    <nx-bform v-if="!linkIAmSmart&&!isCompleted"
            ref="form"
            @submit="onSubmit"
            class="e-registration-professional-register-form"
    >
      <h5>
        {{ $t("title") }}
      </h5>
      <p class="text-muted">
        {{ $t("titleDesc") }}
      </p>

      <nx-bform-server-errors />

      <RegistrationHaveEshAcFormGroup
              label-cols="2"
              label-align="right"
              v-model="form.haveAc"
              required
              v-if="!isExist"
      />

      <template v-if="form.haveAc">
        <RegistrationLoginNameFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.username"
                required
        />

        <RegistrationPasswordFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.password"
                required
        />
      </template>

      <template v-if="!form.haveAc">


        <RegistrationLoginNameNewFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.username"
                required
        />

        <RegistrationPasswordNewFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.password"
                required
        />

        <RegistrationPasswordFormGroup
                :label="$t('confirmPassword')"
                label-cols="2"
                label-align="right"
                v-model="form.confirmPassword"
                required
        />

        <RegistrationEnglishNameFormGroup label-cols="2" label-align="right">
          <div class="plain-text-field">{{ userInfo.nameEng }}</div>
        </RegistrationEnglishNameFormGroup>

        <RegistrationChineseNameFormGroup label-cols="2" label-align="right">
          <div class="plain-text-field">{{ userInfo.nameChinese }}</div>
        </RegistrationChineseNameFormGroup>

        <!-- <RegistrationHKIDNumberFormGroup
          label-cols="2"
          label-align="right"
          description=""
        >
          {{ userInfo.idNo }}
        </RegistrationHKIDNumberFormGroup> -->

        <b-form-group
                :label="$t('certOfRegPosAndNo')"
                label-cols="2"
                label-align="right"
        >
          <!-- <b-form-radio-group
                  v-model="form.defaultPosition"
                  :options="userInfoCerts"
                  stacked
          /> -->
          <div v-for="cert in userInfoCerts" :key="cert.value">
            <div class="plain-text-field">{{ cert.text }}</div>
          </div>
          
        </b-form-group>

        <RegistrationEmailFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.email"
                required
        />

        <!-- <RegistrationTelephoneFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.telephone"
                required
        /> -->

        <RegistrationFaxFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.fax"
        />

        <RegistrationContactAddressLongFormGroup
                label-cols="2"
                label-align="right"
                :address="form.contactAddress"
                required
        />


        <RegistrationESignatureFormGroup
                v-if="businessId"
                label-cols="2"
                label-align="right"
                v-model="form.eCert"
        />

        <RegistrationLanguageFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.lang"
                required
        />

        <CaptchaFormGroup
                label-cols="2"
                label-align="right"
                v-model="form.captcha"
                @change-token="form.captchaToken = $event.token"
                required
        /> 
      </template>

      <nx-bform-server-errors />

      <b-form-group label-cols="2">
        <b-button type="submit" variant="primary" v-t="'send'" />
        <b-button class="ml-2" @click="resetForm" v-t="'cancel'" />
      </b-form-group>
    </nx-bform>
    <AfterRegisterCompleted v-if="isCompleted" :exist="true"  @useESS="useESS"/>
    <AfterLinkedIAmSmart v-if="linkIAmSmart" :exist="false" @useESS="useESS"/>
  </div>
 
</template>

<script>
import { assign } from "lodash";
import { EshApi,MemberRegistrationApi } from "@/api";
import cert from "@/assets/cert.json";
import moment from "moment";
import { FileUtil, UserApi } from "nx-libs";
import { UserService } from "@/services";
import RegistrationEnglishNameFormGroup from "@/forms/registration/RegistrationEnglishNameFormGroup";
import RegistrationChineseNameFormGroup from "@/forms/registration/RegistrationChineseNameFormGroup";
//import RegistrationHKIDNumberFormGroup from "@/forms/registration/RegistrationHKIDNumberFormGroup";
//import RegistrationDateOfBirthFormGroup from "@/forms/registration/RegistrationDateOfBirthFormGroup";
import RegistrationEmailFormGroup from "@/forms/registration/RegistrationEmailFormGroup";
import RegistrationTelephoneFormGroup from "@/forms/registration/RegistrationTelephoneFormGroup";
import RegistrationFaxFormGroup from "@/forms/registration/RegistrationFaxFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import RegistrationLoginNameFormGroup from "@/forms/registration/RegistrationLoginNameFormGroup";
import RegistrationPasswordFormGroup from "@/forms/registration/RegistrationPasswordFormGroup";
import RegistrationPasswordNewFormGroup from "@/forms/registration/RegistrationPasswordNewFormGroup";
import RegistrationESignatureFormGroup from "@/forms/registration/RegistrationESignatureFormGroup";
import RegistrationLanguageFormGroup from "@/forms/registration/RegistrationLanguageFormGroup";
import RegistrationHaveEshAcFormGroup from "@/forms/registration/RegistrationHaveEshAcFormGroup";
import RegistrationLoginNameNewFormGroup from "@/forms/registration/RegistrationLoginNameNewFormGroup";
import RegistrationContactAddressLongFormGroup from "@/forms/registration/RegistrationContactAddressLongFormGroup";
import { IAMSmartAuthApi } from "@nextore/iam-smart";
import AfterLinkedIAmSmart from "../../../login/components/login/AfterLinkedIAmSmart";
import AfterRegisterCompleted from '@/public/modules/login/components/login/AfterRegisterCompleted.vue';

export default {
  props: ["info", "businessId"],
  components: {
    RegistrationEnglishNameFormGroup,
    RegistrationChineseNameFormGroup,
    //RegistrationHKIDNumberFormGroup,
    //RegistrationDateOfBirthFormGroup,
    RegistrationEmailFormGroup,
    RegistrationTelephoneFormGroup,
    RegistrationFaxFormGroup,
    CaptchaFormGroup,
    RegistrationLoginNameFormGroup,
    RegistrationPasswordFormGroup,
    RegistrationPasswordNewFormGroup,
    RegistrationESignatureFormGroup,
    RegistrationLanguageFormGroup,
    RegistrationHaveEshAcFormGroup,
    RegistrationLoginNameNewFormGroup,
    RegistrationContactAddressLongFormGroup,
    AfterLinkedIAmSmart,
    AfterRegisterCompleted
  },
  data() {
    return {
      form: {},
      linkIAmSmart: false,
      isCompleted:false,
      isExist:false,
      memberCertificationGuid:"",
      errors: []
    };
  },
  mounted() {
    this.$watch(
      () => {
        this.errors = this.$refs.form.observer.errors['server-errors']
    }) 
  },
  watch: {
    info: {
      immediate: true,
      handler(info) {
        this.form = this.getForm();
        this.form.email = info[0].email;
        this.form.telephone = info[0].phone;
        this.form.fax = info[0].fax;
        this.isExist = info[0].isExist;
        this.memberCertificationGuid = info[0].memberCertificationGUID;
        if(this.isExist){
          this.form.haveAc = true;
        }
        this.form.contactAddress = {
          contactAddress : info[0].contactAddress,
          contactAddress2 : info[0].contactAddress2,
          contactAddress3 : info[0].contactAddress3,
          contactAddress4 : info[0].contactAddress4,
          contactAddress5 : info[0].contactAddress5
        };
      }
    },
    errors() {
      // console.log("first", $('.form-control.is-invalid:first'))
      // console.log("errors", this.errors)
      // if($('.form-control.is-invalid:first').length > 0) {
        $('.form-control.is-invalid:first')[0].offsetParent.scrollIntoView({behavior: 'smooth'});
      // }
    },
  },
  computed: {
    userInfo() {
      const {
        fullName,
        chineseName,
        hkidNumber,
        passportNumber,
        dateOfBirth,
        email
      } = this.info[0];

      return {
        nameEng: fullName,
        nameChinese: chineseName,
        idDoc: hkidNumber ? "hkid" : "passport",
        idNo: hkidNumber || passportNumber,
        certs: this.info.map((cert) => ({
          certNumber: cert.certNumber,
          position: cert.position
        })),
        birthday: moment.utc(dateOfBirth).format("DD/MM/YYYY"),
        email
      };
    },
    userInfoCerts() {
      return this.userInfo.certs.map((cert) => ({
        text: `${cert.position}, ${cert.certNumber}`,
        value: cert.position
      }));
    },
    sessionKey() {
      return this.info[0].sessionKey;
    },
    eCert() {
      return this.info.eCert;
    }
  },
  methods: {
    getForm() {
      return {
        haveAc: false,
        telephone: "",
        username: "",
        password: "",
        confirmPassword: "",
        lang: "en",
        captcha: "",
        captchaToken: "",
        defaultPosition: null,
        contactAddress: {},
        email: "",
        fax: ""
      };
    },
    async onSubmit(evt) {
       this.$spinner.show();
       try{
        const { form, sessionKey, eCert } = this;
        const registry = {
          sessionKey: this.businessId ? null : sessionKey,
          eCert: this.businessId ? (form.eCert ? await FileUtil.toBase64NoType(form.eCert) : null) : eCert,
          phone: form.telephone,
          defaultPosition: form.defaultPosition
        };

        let login = {
          Username: form.username,
          Password: form.password
        };

        if (!form.haveAc) {
          assign(registry, {
            loginName: form.username,
            pwd1: form.password,
            pwd2: form.confirmPassword,
            language: form.lang,
            contactAddress: form.contactAddress.contactAddress,
            contactAddress2: form.contactAddress.contactAddress2,
            contactAddress3: form.contactAddress.contactAddress3,
            contactAddress4: form.contactAddress.contactAddress4,
            contactAddress5: form.contactAddress.contactAddress5,
            email: form.email,
            fax: form.fax
          });
        }

        if (form.haveAc) {
          await MemberRegistrationApi.loginProfessional({
            LdapID:5,
            Username: form.username,
            Password: form.password,
            SessionKey:this.sessionKey,
            BusinessID:this.businessId,
            MemberCertificationGUID:this.memberCertificationGuid
          });
    

          this.isCompleted=true;
          //await MemberRegistrationApi.upgradeProfessional(registry);
        } else {
          await MemberRegistrationApi.registerProfessional(
            registry,
            this.businessId
          );
          //remove auto login
          //await UserApi.login(5, login);
          this.linkIAmSmart = true;
          // UserService.redirectToLanding("prof");
        }
      }
      finally{
         this.$spinner.hide();
      }
      

    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
      this.$router.push({ name: 'Login' });
    },
    async useESS() {
      this.$router.push({ name: 'Login' });
    }
  }
};
</script>

<style lang="scss" scoped>
.plain-text-field {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/registration.locale"></i18n>

<i18n src="@/locales/login.locale"></i18n>

<i18n>
{
  "en": {
    "title": "To activate a registered professional or contractor account",
    "titleDesc": "Please complete the following (all fields with (*) are mandatory for completion):"
  },
  "zh_hk": {
    "title": "激活註冊的專業人士或承建商帳戶",
    "titleDesc": "請完成以下操作（所有帶有（*）的字段均為必填項）："
  },
  "zh_cn": {
    "title": "激活注册的专业人士或承建商帐户",
    "titleDesc": "请完成以下操作（所有带有（*）的字段均为必填项）："
  }
}
</i18n>
